import React, { useContext, useEffect, useState } from 'react';
import { AuthContext, checkTokenStatus } from '../../App';

import { useDispatch, useSelector } from 'react-redux';
import {
  fetchUserGroups,
  selectAllUserGroups
} from '../../store/slices/userGroupSlice';

import { Button, Divider, useTheme, TextField, Card } from '@mui/material';
import { useParams } from 'react-router';
import Autocomplete from '@mui/material/Autocomplete';
import SearchIcon from '@mui/icons-material/Search';
import { ClipLoader } from 'react-spinners';
import UserGroupCard from '../../components/cards/UserGroupCard';
import CreateUserGroupModal from '../../components/modals/CreateUserGroupModal';
import HierarchicalBreadcrumbs from '../../components/other/HierarchicalBreadcrumbs';

export default function UserGroupsView() {
  const dispatch = useDispatch();
  const userGroupStatus = useSelector((state) => state.userGroups.status);
  const { isLoggedIn, setIsLoggedIn, userData } = useContext(AuthContext);
  let { groupId } = useParams();
  const [selectedGroup, setSelectedGroup] = useState(null);
  const [creatorDisabled, setCreatorDisabled] = useState(false);
  const [showModal, setShowModal] = useState(false);

  const [value, setValue] = useState(null);
  const [inputValue, setInputValue] = useState('');

  useEffect(() => {
    // check if auth token is valid
    if (checkTokenStatus() === false) {
      setIsLoggedIn(false);
      return <navigate to={'/login'} />;
    } else {
      setIsLoggedIn(true);
    }
  }, [setIsLoggedIn]);

  useEffect(() => {
    if (userGroupStatus === 'idle') {
      const token = localStorage.getItem('auth_token');
      dispatch(fetchUserGroups(token));
    }
  }, [userGroupStatus, dispatch]);
  const userGroups = useSelector((state) => selectAllUserGroups(state));

  const theme = useTheme();
  const createUserGroup = () => {
    setShowModal(true);
    setCreatorDisabled(true);
  };

  const handleOnSelect = (item) => {
    if (item === undefined) {
      setSelectedGroup(null);
      setValue(null);
    } else {
      setSelectedGroup(item);
      setValue(item)
    }
  };

  let groupCard;

  if (userGroupStatus === 'loading') {
    groupCard = (
      <div className="text-center">
        <ClipLoader color="#f87171" loading={true} size={100} />
      </div>
    );
  } else if (userGroupStatus === 'succeeded') {
    if (selectedGroup || groupId) {
      groupCard = (
        <div className="flex w-full justify-center">
          {selectedGroup ? (
            <UserGroupCard groupId={selectedGroup.id} />
          ) : (
            <UserGroupCard groupId={groupId} />
          )}
        </div>
      );
    } else {
      groupCard = (
        <p className="text-sm m-10 text-center">
          Enter name to view user group information.
        </p>
      );
    }
  } else {
    groupCard = (
      <p className="text-sm m-10 text-center">
        Enter name to view user group information.
      </p>
    );
  }

  return (
    <div className="UserSettingsView in m-5">
      {showModal && isLoggedIn && userData.role === 'Admin' && (
        <CreateUserGroupModal
          shown={showModal}
          close={() => {
            setShowModal(false);
          }}
          setCreatorDisabled={(val) => {
            setCreatorDisabled(val);
          }}
        />
      )}
      <div className="flex ml-5 justify-between items-center my-2">
        <HierarchicalBreadcrumbs
          outcomes={true}
          userGroups={true}
        />
        {userData?.role === 'Admin' && (
          <Button
            variant="contained"
            onClick={createUserGroup}
            disabled={creatorDisabled}
            sx={{ mx: 1 }}>
            Create User Group
          </Button>
        )}
      </div>

      <Card sx={{ py: 2, m: 3, borderRadius: '0.5rem' }}>
        <div className="mt-4 mx-4">
          <h3 className="text-md font-semibold mb-3">Search for Groups</h3>

          <Autocomplete
            autoHighlight
            options={userGroups}
            clearOnBlur={false}
            value={value}
            onChange={(event, newValue) => {
              handleOnSelect(newValue);
            }}
            inputValue={inputValue}
            onInputChange={(event, newInputValue) => {
              setInputValue(newInputValue);
            }}
            getOptionLabel={(group) => group.name}
            renderInput={(params) =>
              <div className="flex flex-row items-center">
                <TextField {...params} label="Group name" />
                <SearchIcon
                  sx={{ color: 'action.active', mx: 1.5 }}
                  id='search-button'
                  onClick={() => handleOnSelect(userGroups.find((group) => group.name == inputValue))} />
              </div>
            }
          />
        </div>
      </Card>
      <Divider sx={{ mt: 3, mb: 2 }} />

      {groupCard}
    </div>
  );
}
